export enum KioskPaymentMethodPickerStep {
  CHOICE = 'CHOICE',
  TERMINAL = 'TERMINAL',
}
